<div class="toast-icon">
  @if (isV4Design) {
    <i class="fa-light fa-circle-exclamation"></i>
  } @else if (newDesign) {
    <i class="hgi hgi-stroke hgi-alert-02"></i>
  } @else {
    <i
      class="material-icons"
      aria-hidden="true"
      >warning</i
    >
  }
</div>

<!--  TODO: use translations when waxa and payrolls will implement usage of translations in lib"-->
<div class="toast-text">
  Pravdepodobne došlo k výpadku internetu. Skúste stránku načítať znova.
  <div class="toast-actions">
    <button
      type="button"
      (click)="reload()"
      class="btn btn-link right-link"
    >
      Obnoviť
    </button>
  </div>
</div>

<div class="toast-close-button">
  <button
    type="button"
    class="btn btn-link close-btn"
    (click)="removeToast(toast)"
  >
    @if (newDesign) {
      <i class="hgi hgi-stroke hgi-cancel-01"></i>
    } @else {
      <i
        class="material-icons"
        aria-hidden="true"
        >close</i
      >
    }
  </button>
</div>
